import {Injectable} from '@angular/core';
import {HEADERS} from "./constante";
import {Headers, Http, RequestOptions, Response} from '@angular/http';
import {Router, ActivatedRoute, Params} from "@angular/router";
import {Ng4LoadingSpinnerService} from 'ng4-loading-spinner';
import {URL_API} from './constante';
import {Usuario} from "./usuario/usuario";
import {FlashMessagesService} from "angular2-flash-messages";
import {Trabalho} from "./trabalho/trabalho";
import {Evento} from "./eventos/evento";
import {Utils} from "./shared/utils";
import {AcessoService} from "./acesso/acesso.service";

@Injectable()
export class AppService {

    protected loggedIn = false;
    protected documentoUrl:string;

    constructor(protected http: Http,
                protected router: Router,
                protected utils: Utils,
                protected acessoService: AcessoService,
                protected flashMessagesService: FlashMessagesService,
				protected spinnerService: Ng4LoadingSpinnerService) {
        this.loggedIn = !!localStorage.getItem('auth_token');
    }

    search(dados): Promise<Response> {
        let url: string = this.documentoUrl +'/search';
        return this.http
            .post(url, JSON.stringify(dados), {headers: HEADERS})
            .toPromise()
            .then(response => response.json())
            .catch((error) => this.utils.handleError(error));
    }

    get(): Promise<any> {
        return this.http.get(this.documentoUrl)
            .toPromise()
            .then(response => response.json())
            .catch((error) => this.utils.handleError(error));
    }

    get_id(id): Promise<Response> {
        return this.http.get(this.documentoUrl+"/"+id)
            .toPromise()
            .then(response => response.json())
            .catch((error) => this.utils.handleError(error));
    }

    update(dados): Promise<Response> {
        return this.http
            .post(this.documentoUrl + "/update", JSON.stringify(dados), {headers: HEADERS})
            .toPromise()
            .then(response => this.utils.handle(response))
            .catch((error) => this.utils.handleError(error));
    }

    delete(id): Promise<Response> {
        return this.http
            .post(this.documentoUrl + '/delete/' + id, {headers: HEADERS})
            .toPromise()
            .then(response => this.utils.handle(response))
            .catch((error) => this.utils.handleError(error));
    }

    save(dados): Promise<Response> {
        return this.http
            .post(this.documentoUrl, JSON.stringify(dados), {headers: HEADERS})
            .toPromise()
            .then(response => this.utils.handle(response))
            .catch((error) => this.utils.handleError(error));
    }


    // del(dados: any): Promise<Response> {
    //     let url: string = this.documentoUrl + '/delete';
    //     dados['user']= sessionStorage.getItem('api_token');
    //     return this.http
    //         .post(url, dados, {headers: HEADERS})
    //         .toPromise()
    //         .then(response => this.utils.handle(response))
    //         .catch((error) => this.utils.handleError(error));
    // }

    login(usuario: Usuario) {
        return this.http
            .post(URL_API+'/acesso',
                JSON.stringify(usuario),
                {headers: HEADERS})
            .toPromise()
            .then(this.extractData)
            .catch((error) => this.utils.handleError(error));
    }
	
	show(id): Promise<any> {
        return this.http.get(this.documentoUrl + '/' + id, {headers: HEADERS})
            .toPromise()
            .then(response => response.json())
            .catch((error) => this.utils.handleError(error));
    }


    logout() {
        localStorage.removeItem('auth_token');
        this.loggedIn = false;
    }

    isLoggedIn() {
        return this.loggedIn;
    }

    

    private extractData(res: Response) {
        let body = res.json();
        if (body.id != 0) {
            this.router.navigate(['/inicio']);
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/app.service.ts